import { create } from 'zustand'

interface ModalState {
   isAddAssistantsModalOpen: boolean
   openAddAssistantsModal: () => void
   closeAddAssistantsModal: () => void
}

export const useAddAssistantsModalStore = create<ModalState>((set) => ({
   isAddAssistantsModalOpen: false,
   openAddAssistantsModal: () => set({ isAddAssistantsModalOpen: true }),
   closeAddAssistantsModal: () => set({ isAddAssistantsModalOpen: false }),
}))
